import tw, { styled } from "twin.macro";

export const Bordered = styled("div")(({ role }) => [
  tw`flex items-center transition-colors bg-white border rounded-md border-neutral-300`,
  role === "button" && tw`hover:border-neutral-400`,
]);
